import React from 'react';
import { HERO_DESCRIPTION, HERO_EYEBROW, TAGLINE } from '../constants/site';

const PageHero = ({ variant = 'split', showMaterials = false }) => {
  if (variant === 'centered') {
    return (
      <div className="intrall">
        <h4>{HERO_EYEBROW}</h4>
        <h1>{TAGLINE}</h1>
      </div>
    );
  }

  return (
    <div className="intrall-top">
      <div className="intrall lefe">
        <h4>{HERO_EYEBROW}</h4>
        <h1>{TAGLINE}</h1>
      </div>
      <div className="intrall right">
        {showMaterials ? (
          <h1>
            <i className="fa-solid fa-recycle"></i> Materials
          </h1>
        ) : null}
        <p>{HERO_DESCRIPTION}</p>
      </div>
    </div>
  );
};

export default PageHero;
